import React from 'react';
import { Wizard } from 'react-use-wizard';
import InfoDevForm from '../../../informacionDevolucion/components/infoDevForm/infoDevForm';
import HeaderComponent from '../../../../components/header/header_component';
import ConfirmacionDev from '../../../informacionDevolucion/components/confirmacionDev/confirmacionDev';
import cn from '../../../../lib/bem';

import './consuRescaLayout.scss';

const ConsuRescaLayout = ({mostrarPagConsultaRescate}) => {
  
  const classes = cn("consuRescaLayout");

  return (
    <div className={classes()}>
      <HeaderComponent flagHeaderMobile={false} index={false} title={"Consulta de Rescate"}/>
      <Wizard>
        <InfoDevForm 
            titulo="Informaci&oacute;n de Rescate"
            descripcion="Completa la informaci&oacute;n requerida para iniciar con el rescate. Recuerda que t&uacute; debes ser el titular, la cuenta no debe ser mancomunada y estar en la moneda de tu p&oacute;liza."
            nombreMonto="Monto de Rescate disponible"
        />
        <ConfirmacionDev 
          mostrarPolizaMensaje={mostrarPagConsultaRescate}
          descripcion1="Revisa la informaci&oacute;n requerida para iniciar con el rescate. Recuerda que tú debes ser el titular, la cuenta no debe ser mancomunada y estar en la moneda de tu p&oacute;liza. "
          descripcion2=" Nos estaremos comunicando contigo durante el proceso de pago."
          nombreMonto="Monto de Rescate disponible"
          descInfo="Recuerde que si añade otra cuenta que no corresponde al titular de la p&oacute;liza o plan de salud, ser&aacute; rechazada"
          descripcion1Edit="Revisa la informaci&oacute;n requerida para poder iniciar con el rescate. Recuerda que t&uacute; debes ser el titular, la cuenta no debe ser mancomunada y estar en la moneda de tu p&oacute;liza."
          descripcion2Edit="Nos estaremos comunicando contigo durante el proceso de pago."
          nombreMontoEdit="Monto de Rescate disponible"
          descInfoEdit="Esta cuenta quedará guardada para futuros reembolsos."
          descripcionVerificacion="Escribe aqu&iacute; el c&oacute;digo de 6 d&iacute;gitos que hemos enviado  desde contacto@pacificoseguros.com.pe"
        />
      </Wizard>
    </div>
  );
}



export default ConsuRescaLayout;

